import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addMessage } from '../../store/reducers/chat';

import { List, Input, Button, Avatar, Modal, message } from 'antd';
import { SendOutlined, UserOutlined, ConsoleSqlOutlined, CloudUploadOutlined, ApiOutlined, PlusOutlined } from '@ant-design/icons';



import './home.css';
import AddDatabaseModal from '../../components/database';

const ChatInterface = () => {
  const [messages, setMessages] = useState([
    {
      user: 'user',
      text: 'hello',
    },
    {
      user: 'system',
      text: 'I am your intelligent assistant. You can ask me questions for the postgraduate entrance examination.',
    },
  ]);
  const [chatHistory, setChatHistory] = useState(() => {
    const storedHistory = localStorage.getItem('chatHistory');
    return storedHistory ? JSON.parse(storedHistory) : [];
  });
  const [isOver, setIsOver] = useState(true);
  const [isbase, setIsbase] = useState(false);
  const [inputValue, setInputValue] = useState('');
  //选择数据源的窗口
  const [visible, setVisible] = useState(false);
  const [file, setFile] = useState(null);
  //上传文件的窗口
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [dataBaseOpen, setDataBaseOpen] = useState(false);
  const [databaseList, setDatabaseList] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  //发送消息

  const handleSendMessage = () => {


    if (inputValue.trim()) {
      // if (!isbase) {
      //   message.open({
      //     type: 'error',
      //     content: 'Please upload the data source first before starting the chat',
      //   });
      //   return;
      // }
      if (!isOver) {
        message.open({
          type: 'warning',
          content: 'please try again later',
        });
        return;
      }


      const messageToSend = inputValue;

      setMessages(prevMessages => [...prevMessages, { user: 'user', text: messageToSend }]);
      setChatHistory(prevMessages => [...prevMessages, { user: 'user', text: messageToSend }])
      dispatch(addMessage({ user: 'user', text: messageToSend }));
      setIsOver(false)
      setInputValue('');
      sendMessage(messageToSend)
    }
  };
  //选择数据源----打开
  const showModal = () => {
    setVisible(true);
  };
  //选择数据源----关闭
  const handleCancel = () => {
    setVisible(false);
  };
  //上传文件的窗口---打开
  const showModals = () => {
    setIsModalOpen(true);
  };
  //上传文件的窗口----关闭
  const handleOk = () => {
    uploadFile()
    setIsModalOpen(false);
  };
  //上传文件的窗口----关闭
  const handleCancels = () => {
    setIsModalOpen(false);
  };

  const dataBaseOk = () => {
    setDataBaseOpen(false);
  };

  const dataBaseCancels = () => {
    setDataBaseOpen(false);
  };
  //确认增加数据库
  const handleAdd = (values) => {
    // console.log(values);
    setIsModalVisible(false);
    getDatabaseList()
  };
  //关闭增加数据库
  const AddCancel = () => {
    setIsModalVisible(false);
  };
  //展示数据库列表
  const showDataBase = () => {
    setVisible(false);
    getDatabaseList()
    setDataBaseOpen(true);
  };
  //点击选择某一个数据库
  const dataOneClick = async (index) => {
    setDataBaseOpen(false);
    try {
      console.log(databaseList[index]);
      const res = await fetch('//ezhongju.fun/api/select-database', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify({ message: databaseList[index] }),
      });
      // console.log(res);
      setMessages(prevMessages => [
        ...prevMessages,
        {
          user: 'system',
          text: `upload ${databaseList[index].database_name}database is successful, please start your question`
        }
      ]);

      setChatHistory(prevChatHistory => [
        ...prevChatHistory,
        {
          user: 'system',
          text: `upload ${databaseList[index].database_name}database is successful, please start your question`
        }
      ]);
      dispatch(addMessage({ user: 'system', text: `upload ${databaseList[index].database_name}database is successful, please start your question` }));
      setIsbase(true)
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsbase(false)
    }
  }


  //增加数据库
  const showAddModal = () => {
    setIsModalVisible(true);
  }


  let eventSource;
  let currentMessageId; // 用于追踪当前消息的ID

  const sendMessage = async (value) => {
    setLoading(true);
    currentMessageId = Date.now(); // 生成唯一ID

    try {
      if (eventSource) eventSource.close();

      eventSource = new EventSource(`https://ezhongju.fun/api/get-data?message=${encodeURIComponent(value)}`);

      setMessages(prev => [...prev, {
        id: currentMessageId,
        user: 'system',
        text: ''
      }]);
      eventSource.onmessage = (event) => {
        try {
          // 接收到结束标记
          if (event.data === '[DONE]') {
            setIsOver(true);
            eventSource?.close();
            eventSource = null;
            setIsOver(true);
            return;
          }
          const data = JSON.parse(event.data); // 解析事件数据
          const answer = data.answer || '';
          setMessages(prev => {
            const targetIndex = prev.findIndex(msg => msg.id === currentMessageId);
            if (targetIndex === -1) return prev;

            const newText = prev[targetIndex].text + answer;

            // 当首次有有效内容时关闭加载
            if (newText.length > 0 && prev[targetIndex].text === '') {
              setLoading(false); // 关闭加载动画
            }

            return prev.map((msg, index) =>
              index === targetIndex
                ? { ...msg, text: newText }
                : msg
            );
          });
        } catch (err) {
          console.error('数据解析失败:', err);
        }
      };

      eventSource.onerror = () => {
        eventSource?.close();
        eventSource = null;
        setIsOver(true);

        // 仅当无内容时显示错误
        setMessages(prev => {
          const hasContent = prev.some(msg => msg.id === currentMessageId && msg.text);
          return hasContent
            ? prev
            : [...prev, { user: 'system', text: "请求失败，请重试" }];
        });

      };

    } catch (error) {

    } finally {
      // eventSource.close();


    }
  };


  const getDatabaseList = async () => {
    try {
      // 使用fetch发起GET请求
      const response = await fetch('//ezhongju.fun/api/get-baseList', {
        method: 'GET',
        mode: 'cors',
      })
      // 检查响应状态
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      // 解析JSON数据
      const result = await response.json();
      // 将数据存储到状态中
      // console.log(result);
      setDatabaseList(result.data);
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
    }
  };

  //上传文件
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(file);

    handleCancel()
    showModals()
  };

  //向后端上传文件
  const uploadFile = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await fetch('//ezhongju.fun/api/upload', {
        method: 'POST',
        body: formData,
        mode: 'cors',
      }
      );
      const result = await res.json();
      console.log('File upload response:', result);
      setMessages(prevMessages => [
        ...prevMessages,
        { user: 'system', text: `${result.message}` }
      ]);

      setChatHistory(prevChatHistory => [
        ...prevChatHistory,
        { user: 'system', text: `${result.message}` }
      ]);
      dispatch(addMessage({ user: 'system', text: `${result.message}` }));
      setIsbase(true)
    } catch (error) {
      console.error('Error uploading file:', error);
      setIsbase(false)

      setMessages(prevMessages => [
        ...prevMessages,
        { user: 'system', text: `${error}` }
      ]);

      setChatHistory(prevChatHistory => [
        ...prevChatHistory,
        { user: 'system', text: `${error}` }
      ]);
      dispatch(addMessage({ user: 'system', text: `${error}` }));
    }
  };

  const renderMessage = (message, index) => {
    const isUserMessage = message.user === 'user';
    return (
      <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 10 }}>
        {isUserMessage ? (
          <Avatar icon={<UserOutlined />} style={{ marginRight: 10 }} size="large" />
        ) : (
          <Avatar style={{ backgroundColor: 'blue', marginRight: 10 }} size="large"
            icon={<ConsoleSqlOutlined />} />
        )}
        <div key={index} className={isUserMessage ? 'user-message' : 'other-message'} style={{ marginBottom: 10, padding: 10, borderRadius: 10 }}>
          <div>
            <p style={{ margin: 0, fontSize: 16 }}>{message.text}</p>
          </div>
        </div>
      </div>
    );
  };
  // useEffect(() => {
  //   // const storedHistory = localStorage.getItem('chatHistory');
  //   // if (storedHistory) {
  //   //   setChatHistory(JSON.parse(storedHistory));
  //   // }
  //   if (chatHistory) {
  //     setChatHistory(JSON.parse(chatHistory));
  //   }
  // }, []);


  useEffect(() => {
    // const handleBeforeUnload = () => {
    //   localStorage.setItem('chatHistory', JSON.stringify(chatHistory));
    // };

    // window.addEventListener('beforeunload', handleBeforeUnload);
    // return () => {
    //   window.removeEventListener('beforeunload', handleBeforeUnload);
    //   localStorage.setItem('chatHistory', JSON.stringify(chatHistory));
    // };
    localStorage.setItem('chatHistory', JSON.stringify(chatHistory));
  }, [chatHistory]);


  return (
    <div className="chat-container">
      <div className="message-list-container">
        <List
          dataSource={messages}
          renderItem={(message, index) => renderMessage(message, index)}
        />
        {loading && <div className="box" >
          <span></span>
          <span></span>
          <span></span>
        </div>}
      </div>
      <div className='send'>
        <div className="input-container">
          <Input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Send a message to Data-AI"
            onPressEnter={handleSendMessage}
          />
          {/* <Button
            onClick={showModal}
            style={{ marginLeft: 10, marginRight: 10 }}
          >
            Select data source
          </Button> */}

          <Button type="primary"
            onClick={handleSendMessage}
            style={{ marginLeft: 10, width: 45 }}
            icon={<SendOutlined />}>
          </Button>
        </div>
      </div>
      <Modal
        title="Select Data Source"
        open={visible}
        onCancel={handleCancel}
        footer={null}
        width={600}
      >
        <p className='modal-content'>
          Before using AI for data analysis, you need to first select the data source.
          You can choose to upload data files or select a connected database as the data source.
        </p>
        <div className='modal-button'>
          <Button type="primary" size='large'
            icon={<CloudUploadOutlined />}
            style={{ position: 'relative' }}>
            <input type="file" onChange={handleFileChange}
              style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }} />
            Upload files
          </Button>
          <Button type="primary" style={{ marginLeft: 8 }} size='large'
            icon={<ApiOutlined />}
            onClick={showDataBase}
          >
            Select Database
          </Button>
        </div>
      </Modal>
      {/* ---------------------- */}
      <Modal title="Choose" open={isModalOpen} onOk={handleOk} onCancel={handleCancels}>
        <p className='modal-content'>Are you sure you want to use this as your data source?</p>
      </Modal>
      <Modal title="Data base" open={dataBaseOpen} onOk={dataBaseOk} onCancel={dataBaseCancels} footer={null}>
        {databaseList && databaseList.map((item, index) => (
          <div key={index} className='databaselists' onClick={() => dataOneClick(index)}>
            <div className='sicon'>
              <ApiOutlined style={{ fontSize: '30px', color: '#08c' }} />
            </div>
            <div className='anme'>
              <h3>{item.database_name}</h3>
              <span>type: {item.type}</span>
            </div>
          </div>
        ))}
        <div className='databaselists' onClick={showAddModal}>
          <div className='sicon'>
            <PlusOutlined style={{ fontSize: '30px', color: '#08c' }} />

          </div>
          <div className='anme'>
            <h3>Click here to add database</h3>
          </div>
        </div>
      </Modal>
      <AddDatabaseModal
        visible={isModalVisible}
        onCancel={AddCancel}
        onAdd={handleAdd}
      />
    </div>
  );
};

export default ChatInterface;